



import {Component, Vue} from 'vue-property-decorator'
import RoomsList from '@/components/rooms/RoomsList.vue'

@Component({
  components: {
    RoomsList,
  },
})
export default class Rooms extends Vue {}
